/* MAIN */
// Just a convenient wrapper around Float32Array, abstracting away that we always use Float32Array
class Buffer extends Float32Array {
}
/* EXPORT */
export default Buffer;
